import type { AppointmentForm } from '@devexpress/dx-react-scheduler-material-ui';
import React from 'react';

import { DateInput } from '@components/DateInput';

/**
 * VITALL-styled date editor component for the routine form
 */
export const DateEditor = ({ ...props }: AppointmentForm.DateEditorProps) => {
  const { value, onValueChange } = props;
  return (
    <DateInput
      onChange={(value) => {
        if (value) {
          onValueChange(value);
        }
      }}
      value={value}
    />
  );
};

export default DateEditor;
